import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "pages/NotFound";
import ShoppingCart from './pages/shopping-cart';
import UserLogin from './pages/user-login';
import ProductCatalog from './pages/product-catalog';
import AdminDashboard from './pages/admin-dashboard';
import ProductDetails from './pages/product-details';
import UserRegistration from './pages/user-registration';
import UserAccountDashboard from './pages/user-account-dashboard';
import VendorManagement from './pages/vendor-management';
import AdminProducts from './pages/admin-products';
import AdminOrders from './pages/admin-orders';
import AdminCustomers from './pages/admin-customers';
import AdminVendors from './pages/admin-vendors';
import AdminAnalytics from './pages/admin-analytics';
import AdminSettings from './pages/admin-settings';
import AdminHelp from './pages/admin-help';
import LandingPage from './pages/landing-page';
import About from './pages/about';
import VerifyEmail from './pages/verify-email';
import Wishlist from './pages/wishlist';
import CheckoutPage from './pages/checkout';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/product-catalog" element={<ProductCatalog />} />
            <Route path="/product-details" element={<ProductDetails />} />
            <Route path="/user-login" element={<UserLogin />} />
            <Route path="/user-registration" element={<UserRegistration />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/shopping-cart" element={<ShoppingCart />} />
            
            {/* Protected routes - User dashboard */}
            <Route 
              path="/user-account-dashboard" 
              element={
                <ProtectedRoute requiredRole="user">
                  <UserAccountDashboard />
                </ProtectedRoute>
              } 
            />

            {/* Alternative account path for easier access */}
            <Route 
              path="/account" 
              element={
                <ProtectedRoute requiredRole="user">
                  <UserAccountDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected routes - Admin dashboard */}
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Products */}
            <Route 
              path="/admin/products" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminProducts />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Orders */}
            <Route 
              path="/admin/orders" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminOrders />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Customers */}
            <Route 
              path="/admin/customers" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminCustomers />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Vendors */}
            <Route 
              path="/admin/vendors" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminVendors />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Analytics */}
            <Route 
              path="/admin/analytics" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminAnalytics />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Settings */}
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminSettings />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Admin Help */}
            <Route 
              path="/admin/help" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminHelp />
                </ProtectedRoute>
              } 
            />

            {/* Protected routes - Vendor Management */}
            <Route 
              path="/vendor-management" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <VendorManagement />
                </ProtectedRoute>
              } 
            />
            
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;